export function extractString(val, fallback = '') {
  if (val === null || val === undefined) return fallback;
  if (typeof val === 'string') return val.trim();
  if (typeof val === 'number') return String(val);
  if (typeof val === 'boolean') return String(val);
  if (typeof val === 'object') {
    if (val.value !== undefined) return extractString(val.value, fallback);
    if (val.name !== undefined) return extractString(val.name, fallback);
    if (val.text !== undefined) return extractString(val.text, fallback);
    if (val.stringValue !== undefined) return extractString(val.stringValue, fallback);
  }
  return fallback;
}

export function extractOrder(val, fallback = 999) {
  if (val === null || val === undefined) return fallback;
  if (typeof val === 'number') return isNaN(val) ? fallback : val;
  if (typeof val === 'string') {
    const parsed = Number(val);
    return isNaN(parsed) ? fallback : parsed;
  }
  if (typeof val === 'object') {
    if (val.order !== undefined) return extractOrder(val.order, fallback);
    if (val.value !== undefined) return extractOrder(val.value, fallback);
    if (val.integerValue !== undefined) return extractOrder(val.integerValue, fallback);
  }
  return fallback;
}
